import { useQuery } from "@tanstack/react-query";
import { DataLoading } from "../types/dataLoading";
import { SiteEvent } from "../types/siteEvent";
import dayjs from "dayjs";

type FetchSiteEventsParams = {
  siteId: string;
  searchPeriod: { from: string; to: string };
};

// MOCK SERVICE: to be replaced with actual service when the API exists using baseFetch
const fetchSiteEvents = async (
  params: FetchSiteEventsParams
): Promise<SiteEvent[]> => {
  try {
    const response = await fetch("/siteEvents.json");
    if (!response.ok) {
      throw new Error(`Error fetching site events: ${response.statusText}`);
    }
    const data: SiteEvent[] = await response.json();

    const from = new Date(params.searchPeriod.from);
    const to = new Date(params.searchPeriod.to);
    const events: SiteEvent[] = data.map((event) => ({
      ...event,
      date: new Date(event.date),
    }));
    const filteredData = events.filter(
      (event) =>
        dayjs(event.date) >= dayjs(from) &&
        dayjs(event.date) <= dayjs(to).endOf("day")
    );

    return filteredData;
  } catch (error) {
    console.error("Error fetching events:", error);
    throw new Error(`Error fetching events ${error}`);
  }
};

const useSiteEventsQuery = (params: FetchSiteEventsParams) => {
  return useQuery({
    queryKey: ["siteEvents", params.siteId, params.searchPeriod],
    queryFn: () =>
      fetchSiteEvents({
        siteId: params.siteId,
        searchPeriod: params.searchPeriod,
      }),
    // Consider data fresh for 5 minutes
    staleTime: 5 * 60 * 1000,
    // Keep unused data in cache for 30 minutes
    gcTime: 30 * 60 * 1000,
  });
};

export { fetchSiteEvents, useSiteEventsQuery };
export type { FetchSiteEventsParams };
